<div class="{{tenantCode}}-theme p-4 w-100">
    <h1>Please note:</h1>
    <p>{{popoverText}}</p>
    
    <div class="d-flex flex-row justify-content-end w-100 mt-3">
        <app-button class="float-right ms-3" title="Okay" icon="check" (onClick)="close()"></app-button>
    </div>
</div>